import { FlexRow } from '@/components/common/Flex';
import { FlexProps, StackDivider, StackProps, VStack } from '@chakra-ui/react';
import { hoverStyleProps } from './styleHelpers';
import { Text } from './Typography';

export interface KeyValueStackItem {
    key: string | JSX.Element;
    value: string | JSX.Element;
    onClick?: () => void;
}

export interface KeyValueStackProps extends StackProps {
    items: KeyValueStackItem[];
    itemProps?: FlexProps;
    withEndLine?: boolean;
    valueAlign?: 'left' | 'right';
}

export default function KeyValueStack({
    items,
    itemProps,
    withEndLine,
    valueAlign = 'right',
    ...props
}: KeyValueStackProps) {
    return (
        <VStack
            divider={<StackDivider borderColor="gray.100" />}
            align="stretch"
            spacing={0}
            {...props}
        >
            {items.map(({ key, value, onClick }, index) => (
                <FlexRow
                    key={index}
                    align="center"
                    onClick={onClick}
                    py={3}
                    {...(onClick
                        ? hoverStyleProps({
                              mx: -3,
                              px: 3,
                              bg: 'gray.100',
                          })
                        : {})}
                    {...itemProps}
                >
                    <FlexRow grow={1} basis={0}>
                        {typeof key === 'string' ? (
                            <Text fontWeight="medium">{key}</Text>
                        ) : (
                            key
                        )}
                    </FlexRow>
                    <FlexRow
                        grow={1}
                        basis={0}
                        justify={
                            valueAlign === 'right' ? 'flex-end' : 'flex-start'
                        }
                    >
                        {typeof value === 'string' ? (
                            <Text
                                textAlign={
                                    valueAlign === 'right' ? 'right' : 'left'
                                }
                            >
                                {value}
                            </Text>
                        ) : (
                            value
                        )}
                    </FlexRow>
                </FlexRow>
            ))}
            {withEndLine ? <></> : null}
        </VStack>
    );
}
